import { render, staticRenderFns } from "./admin-login.vue?vue&type=template&id=02c5274f&scoped=true"
import script from "./admin-login.vue?vue&type=script&lang=js"
export * from "./admin-login.vue?vue&type=script&lang=js"
import style0 from "./admin-login.vue?vue&type=style&index=0&id=02c5274f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c5274f",
  null
  
)

export default component.exports